/**
 * If an order would come through that would result in 0 qty. could be bc user attempted to sell 10% of an order with 1 qty,
 * or that he actually entered 0. etc...
 * {
	"messageType": "alertNotification",
	"notificationId": 1645798669141,
	"notificationDetails": {"errorType":"ORDER_VALIDATION","notificationType":"ERROR","TRADE_PLAN":{"type":"BASIC_TRADING_SYSTEM","id":1,"symbol":"XYZ"}},
	"status": "ZERO_ORDER_QUANTITY",
	"statusDetails": {"symbol":"XYZ"},
	"date": "2022-02-25T09:17:49.897-0500",
	"timestamp": "1645798669900"
}
 * @param {*} statusDetails 
 * @returns object with field:
 * 1) symbol. the symbol of the order with zero qty
 */
export function zeroOrderQtyParser(statusDetails) {
  const parsedObj = {
    symbol: null,
  };
  if (statusDetails) {
    parsedObj.symbol = statusDetails.symbol ?? null; 
  }

  return parsedObj;
}
